import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { webUrlNode } from "../../../constants/appInfo";

  import { useRouteMatch,Switch, Route } from "react-router-dom";
  import { useHistory,} from "react-router-dom";
import CreateBatchPopup from "./CreateBatchPopup";
import AdminBatchDashboardCard from "./AdminBatchDashboardCard";
import AdminCourseBatchesCard from "./AdminCourseBatchesCard";
import AddBatchContentPopup from "./AddBatchContentPopup";
import BatchContents from "./BatchContents";
import { Plus } from "lucide-react";
import AddStudentsToBatchModal from "./AddStudentsToBatchModal";
import BatchStudentsList from "./BatchStudentsList";
import HomeworkPanel from "./HomeworkPanel";
  
export default function AdminCourseBatcheDash({
    loadBatches
  
  
}) {
    
      const {url}=useRouteMatch();
   const history = useHistory();
 
        const courseData = useSelector((state)=>state?.course?.course);

const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visibility, setVisibility] = useState('public');


const domain = useSelector((state)=>state?.app?.app?.domain);
      const coursePostId = useSelector((state)=>state?.course?.course?.postId);
        const currentToken = useSelector((state)=>state?.user?.user?.token);
             const userEmail = useSelector((state)=>state?.user?.user?.user_email
            );
            


  return (
 <div  style={{background:"#ffffff",padding:"5px",borderRadius:"15px",overflow:"hidden"}} >
        <div  style={{background:"#ffffff"}}>
        
            
          

      <div style={{ marginBottom: 12 }}>
        
       <div style={{background:"#ffffff",borderRadius:"15px",marginLeft:"3px",marginRight:"3px",marginTop:"-5px",padding:"10px"
    ,display:"flex",justifyContent:"space-between"}}> <div style={{ fontSize: 12, color: "#666",width:"180px", }}>
        <div><h1 style={{ margin: 0 }} > Course Batches</h1>  <h4 className="ButtonWithEllipsis"  >Course: {courseData?.productName}</h4> 
        </div>  
        </div><div style={{width:"130px",height:"35px",position:"relative",fontSize:"20px",background:"rgb(249, 201, 199)",color:"#222",
        padding:"5px 3px" ,borderRadius:"5px",cursor:"pointer",zIndex:"9",display:"flex",justifyContent:"center",alignItems:"center"}} 
        onClick={() => setOpen(true)}>
  <Plus size={20} color="#222222"/> <span>Create Batch</span>
</div></div>
      </div>   </div>   
       
   
<CreateBatchPopup
  open={open}
  onClose={() => setOpen(false)}
  domain={domain}
  coursePostId={coursePostId}
  onCreated={(b) => { 
    history.push(`${url}/dash/${b.batchId}`);
    // reload your batches list
    
  }}
/>
      <switch>
        <Route  exact path={`${url}/dash/:batchId?`}>
    <AdminBatchDashboardCard
  
    onEdit={() => {}}
  />
</Route> <Route  exact path={`${url}/dash/:batchId?/content-drip`}>
    <BatchContents 
  
    onEdit={() => {}}
  />
</Route>
 <Route  exact path={`${url}/dash/:batchId?/batch-students`}>
    <BatchStudentsList />
 
</Route>
 <Route  exact path={`${url}/dash/:batchId?/batch-homeworks`}>
    <HomeworkPanel />
 
</Route>


    <Route exact path={`${url}`}>
  <AdminCourseBatchesCard
   open={open}
     setOpen={() => setOpen(false)}
         />
</Route> 


</switch>
    </div>
  );
}



